export default __webpack_public_path__ + "static/home-andy-video-thumb-0edd660f64ec259c91ec51f6a600e389.png";